import { GOOGLE_MAPS_API_KEY } from '@shared/constants/googlemaps';
import { loadScript } from './loadScript';

export async function loadGoogleMapsApi(window) {
  const src = 'https://maps.googleapis.com/maps/api/js?key=' + GOOGLE_MAPS_API_KEY + '&libraries=places';
  return await loadScript(window, src);
}
